import { createAction } from '@reduxjs/toolkit';

export const setOnline = createAction('connection/setOnline');
export const setOffline = createAction('connection/setOffline');
export const checkConnection = createAction('connection/checkConnection');
// A requested check found the backend reachable while already online.
export const connectionVerified = createAction('connection/verified');
